import {sbkCoreBreakpointLg} from '@/tokens/variables';
import { css, unsafeCSS } from 'lit';

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const oipModuleItemStyle = css`
    :host {
        position: relative;
    }

    .container {
        background-color: var(--sbkTeaserColorBgColorDefault);
        color: var(--sbkTeaserColorFgColorOnLightEnabled);
        border-radius: var(--sbkTeaserBorderRadiusDefault);
        font: var(--sbkTeaserTypographySmallScreenBodySm);
        overflow: hidden;
        outline-offset: var(--sbkTeaserBorderGapFocus);
        border: 1px solid transparent;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        padding: var(--sbkTeaserSpacingSmallScrInsetTop) var(--sbkTeaserSpacingSmallScrInsetRight) var(--sbkTeaserSpacingSmallScrInsetBottom) var(--sbkTeaserSpacingSmallScrInsetLeft);

        @media (min-width: ${breakpointLg}) {
            gap: var(--sbkTeaserSpacingLargeScrGap);
            padding: var(--sbkTeaserSpacingLargeScrInsetTop) var(--sbkTeaserSpacingLargeScrInsetRight) var(--sbkTeaserSpacingLargeScrInsetBottom) var(--sbkTeaserSpacingLargeScrInsetLeft);
        }

        &:focus-visible {
            outline: var(--sbkTeaserBorderFocus);
            border-radius: var(--sbkTeaserBorderRadiusFocus);
        }

        &:hover {
            border: var(--sbkTeaserBorderHover);
        }
    }
    
    .buttons {
        display: flex;
        flex-direction: row;
    }
`;
